export default {
  server: {
    showOverlay: null,
    overlayMessage: null,
    overlayFunction: null
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/httpRequests/state.js
// module id = null
// module chunks = 